import $ from "jquery";
import { Cookie } from "../../../angular-app-handlers";
import {TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP} from "../../bell-curve-report-parameter/reducers/bell-curve-report-parameter-reducer";
import { HIDE_LOADER, SHOW_LOADER } from "../../mdae-common-reducer";
export const MDAI_MODULE = {
  REVENUE_OPTIMIZER: "REVENUE_OPTIMIZER",
  AUDIT_INSIGHTS: "AUDIT_INSIGHTS",
  EXTERNAL_AUDIT_INSIGHTS: "EXTERNAL_AUDIT_INSIGHTS",
  PROCEDURE_UTILIZATION: 'PROCEDURE_UTILIZATION', 
  ROI_SUMMARY: "ROI_SUMMARY", 
};
export interface IMdaiSettings {
  mdaiAIUserName: string;
  mdaiROUserName: string;
  mdaiEAUserName: string;
  mdaiPUUserName: string;
  mdaiROIUserName: string;
  mdaiBaseUrl: string;
  mdaiSecretKey: string;
  adminUser: string;
  mdaiModule: string;
  dispatch:any;
  history:any;
}
const onThoughtSpotLoginAction = function(
  redirectUrl,
  mdaiAIUserName,
  mdaiROUserName,
  mdaiEAUserName,
  mdaiPUUserName,
  mdaiROIUserName,
  adminUser,
  mdaiBaseUrl,
  mdaiSecretKey,
  mdaiModule,
  dispatch,
  history
) {
  var clientIdCookie = Cookie.get("MDAuditEnterprise_ClientIdCookie");
  if (clientIdCookie == null) {
    window.location.href = "/Account/Logout";
  } else {
    var username = "";
    if (mdaiModule === MDAI_MODULE.REVENUE_OPTIMIZER) {
       username = mdaiROUserName;
    }
    else if(mdaiModule === MDAI_MODULE.AUDIT_INSIGHTS) {
      username = mdaiAIUserName;
    }
    else if(mdaiModule === MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS) 
    {
      username = mdaiEAUserName;
    }
    else if(mdaiModule === MDAI_MODULE.ROI_SUMMARY){
      username = mdaiROIUserName;
    }
    else 
    {
      username = mdaiPUUserName;
    }
    dispatch({ type: SHOW_LOADER });
    $.ajax(mdaiBaseUrl + "/callosum/v1/session/auth/token", {
      type: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "text/plain",
        "X-Requested-By": "ThoughtSpot",
        "User-Agent": "HayesManagement",
      },
      data: {
        username: username,
        secret_key: mdaiSecretKey,
        access_level: "FULL",
      },
      xhrFields: {
        withCredentials: true,
      },
      success: function(data) {
        $.ajax(mdaiBaseUrl + "/callosum/v1/session/login/token", {
          type: "GET",
          headers: {
            Accept: "text/plain",
            "X-Requested-By": "ThoughtSpot",
          },
          data: {
            username: username,
            auth_token: data,
          },
          xhrFields: {
            withCredentials: true,
          },
          success: function(data) {
            localStorage.setItem("MdaiBaseUrl", mdaiBaseUrl);
            
            let currentBrowserTitle: string = $("#pnlMdaeBrowserTitle").html();
            console.log(currentBrowserTitle);
            
            if(currentBrowserTitle === "Analyzer") {
              if(redirectUrl.includes("/mdai/")) { 
                if(redirectUrl.includes("/externalaudit/")) {
                  window.open(redirectUrl);
                }  else {
                  history.push(redirectUrl);
                }
              } else if(redirectUrl.includes("externalaudit")){
                history.push(redirectUrl);
              } else  {
                window.open(redirectUrl);
              }
            } else if (currentBrowserTitle === "Payer Audit") {
              if(redirectUrl.includes("/mdai/")) { 
                if(redirectUrl.includes("/externalaudit/")) {
                  history.push(redirectUrl);
                }  else {
                  window.open(redirectUrl);
                }
              } else if(redirectUrl.includes("externalaudit")){
                history.push(redirectUrl);
              } else  {
                window.open(redirectUrl);
              }
            }else {
              window.open(redirectUrl);
            }
            
            
            dispatch({ type: HIDE_LOADER });
          },
          error: function() {
            dispatch({ type: HIDE_LOADER });
            alert("Login Failed. Please contact Administrator.");
            dispatch({ type: HIDE_LOADER });
          },
        });
      },
      error: function(data) {
        dispatch({ type: HIDE_LOADER });
        alert("Login Failed. Please contact Administrator.");
        dispatch({ type: HIDE_LOADER });
      },
    });
  }
};

const openCodeLookupWindow = () => {
  window.open(
    "/lookup/index",
    "Code Search",
    "width=1220,height=600,scrollbars=1"
  );
  return false;
};
const onSwitchToAnalytics = () => {
  window.open("/Analyzer");
};
const onSwitchToAnalyticsBellCurveReport = function(e) {
   window.open("/Analyzer?IsBellCurveReport=true");
 };
const onSwitchToAudits = () => {
  window.open("/Home/Dashboard");
};

const onBellCurveReportParameterClick = (dispatch) =>{
  dispatch({
    type: TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP,
    data: {
        isbellCurveReportParameterPopupVisible: true,
    },
  });
}

const mdaiMenuClickHandlers = {
  callLoginAction: (pageUrl, mdaiSettings) => {
    onThoughtSpotLoginAction(
      pageUrl,
      mdaiSettings.mdaiAIUserName,
      mdaiSettings.mdaiROUserName,
      mdaiSettings.mdaiEAUserName,
      mdaiSettings.mdaiPUUserName,
      mdaiSettings.mdaiROIUserName,
      mdaiSettings.adminUser,
      mdaiSettings.mdaiBaseUrl,
      mdaiSettings.mdaiSecretKey,
      mdaiSettings.mdaiModule,
      mdaiSettings.dispatch,
      mdaiSettings.history
    );
  },
  onAccessThoughtSpotAuditActivitySummaryInternal: (
    mdaiSettings: IMdaiSettings
  ) => {
    const pageUrl = "/mdai/auditactivitysummaryinternal/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAuditActivitySummaryExternal: (mdaiSettings) => {
    const pageUrl = "/mdai/auditactivitysummaryexternal/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAuditResultsSummaryExecutive: (mdaiSettings) => {
    const pageUrl = "/mdai/auditresultssummaryexecutive/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAuditResultsSummaryFocused: (mdaiSettings) => {
    const pageUrl = "/mdai/auditresultssummaryfocused/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAuditTargetAnalysesIP: (mdaiSettings) => {
    const pageUrl = "/mdai/audittargetanalysesIP/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAuditTargetAnalysesOP: (mdaiSettings) => {
    const pageUrl = "/mdai/audittargetanalysesOP/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAuditTargetAnalysesProfessional: (mdaiSettings) => {
    const pageUrl = "/mdai/audittargetanalysesprofessional/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotExecutiveOverviewReports: (mdaiSettings) => {
    const pageUrl = "/mdai/executiveoverview/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotChargePaymentAnalysesReports: (mdaiSettings) => {
    const pageUrl = "/mdai/chargepaymentanalyses/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtpProcessUtilization: (mdaiSettings) => {
    const pageUrl = "/mdai/procedureutilization/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotProcessUtilizationHospitalClaims: (mdaiSettings) => {
    const pageUrl = "/mdai/procedureutilization/hospitalclaims";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotExecutiveOverviewCMIScoresReports: (mdaiSettings) => {
    const pageUrl = "/mdai/executiveoverviewcmiscores/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotDenialTrendingAnalysisReports: (mdaiSettings) => {
    const pageUrl = "/mdai/denialtrendinganalysis/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotDenialTrendingAnalysisProfessionalReports: (
    mdaiSettings
  ) => {
    const pageUrl = "/mdai/targeteddenialanalysisprofessional/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotDenialTrendingAnalysisInstitutionalReports: (mdaiSettings) => {
    const pageUrl = "/mdai/targeteddenialanalysisinstitutional/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotSelfServiceSearch: (mdaiSettings) => {
    const pageUrl = "/mdai/selfsearch/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotEaAllInsights: (mdaiSettings) => {
    const pageUrl = "/mdai/allinsights?isforea=true";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotPuAllInsights: (mdaiSettings) => {
    const pageUrl = "/mdai/allinsights?isforpu=true";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotRoAllInsights: (mdaiSettings) => {
    const pageUrl = "/mdai/allinsights?isforro=true";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotEaSelfServiceSearch: (mdaiSettings) => {
    const pageUrl = "/mdai/selfsearch?isforea=true";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotPuSelfServiceSearch: (mdaiSettings) => {
    const pageUrl = "/mdai/selfsearch?isforpu=true";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotRoSelfServiceSearch: (mdaiSettings) => {
    const pageUrl = "/mdai/selfsearch?isforro=true";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtSpotAllInsights: (mdaiSettings) => {
    const pageUrl = "/mdai/allinsights";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    },
    onAccessExternalAuditInsights:(mdaiSettings) => {

    },
    onAccessDepartmentSummary:(mdaiSettings) => {
      const pageUrl="/externalaudit/mdai/departmentsummary";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    },
    onAccessEAWBenchmarks:(mdaiSettings) => {
      const pageUrl="/externalaudit/mdai/eawbenchmarks";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    },
    onAccessRequesterSummary:(mdaiSettings) => {
      const pageUrl="/externalaudit/mdai/requestersummary";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    },
    onAccessExternalAuditResults:(mdaiSettings) => {
      const pageUrl="/externalaudit/mdai/externalauditresults";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    },
    onAccessExternalAuditTargets:(mdaiSettings) => {
      const pageUrl="/externalaudit/mdai/externalaudittargets";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    },
  onAccessThoughtSpotAuditResultsSummaryProviderGroupRisks: (mdaiSettings) => {
    const pageUrl = "/mdai/auditresultssummaryprovidergrouprisks/";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
    OnAccessSpotIQAllResults: (mdaiSettings) => {
        const pageUrl = "/mdai/spotiqresults/";
        mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    }, 
    OnAccessSpotEaIQAllResults: (mdaiSettings) => {
      const pageUrl = "/mdai/spotiqresults?isforea=true";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },   
    OnAccessSpotIQPuAllResults: (mdaiSettings) => {
      const pageUrl = "/mdai/spotiqresults?isforpu=true";
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
    OnAccessSpotIQRoAllResults: (mdaiSettings) => {
        const pageUrl = "/mdai/spotiqresults?isforro=true";
        mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
  },
  onAccessThoughtspotiConfigureDenialsPredictor: (mdaiSettings) => {
    const pageUrl = "/Analyzer/ConfigureDenialsPredictor";
    if(mdaiSettings.mdaiROUserName != null)
      mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
    else window.open(pageUrl);
},
onAccessThoughtSpotAuditROI: (mdaiSettings) => {
  const pageUrl = "/mdai/auditroi";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotPayerAuditROI: (mdaiSettings) => {
  const pageUrl = "/mdai/payerauditroi";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotProfessionalProviderRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/professionalproviderrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotProfessionalCoderRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/professionalcoderrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotProfessionalPayerRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/professionalpayerrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotProfessionalTopCodes: (mdaiSettings) => {
  const pageUrl = "/mdai/professionaltopcodes";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotOutpatientFacilityRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/outpatientfacilityrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotOutpatientCoderRisk: (mdaiSettings) => {
    const pageUrl = "/mdai/outpatientcoderrisk";
    mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotOutpatientPayerRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/outpatientpayerrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotOutpatientTopCodes: (mdaiSettings) => {
  const pageUrl = "/mdai/outpatienttopcodes";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotInpatientFacilityRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/inpatientfacilityrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotInpatientCoderRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/inpatientcoderrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotInpatientPayerRisk: (mdaiSettings) => {
  const pageUrl = "/mdai/inpatientpayerrisk";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
onAccessThoughtSpotInpatientTopCodes: (mdaiSettings) => {
  const pageUrl = "/mdai/inpatienttopcodes";
  mdaiMenuClickHandlers.callLoginAction(pageUrl, mdaiSettings);
},
    
};
export {
  Cookie,
  onThoughtSpotLoginAction,
  openCodeLookupWindow,
  onSwitchToAnalytics,
  onSwitchToAudits,
  onBellCurveReportParameterClick,
  mdaiMenuClickHandlers,
  onSwitchToAnalyticsBellCurveReport
};
